/** Card de documento no chat — nome sempre visível; link só se houver URL persistida. */
import React, { useMemo } from 'react';
import { AppIcon } from '../../../../../components/icons/AppIcon';
import { sanitizeUrl } from '../../../../../utils/sanitize';
import { MediaInfo, safeParse } from './types.js';

interface DocumentMediaProps {
    media: MediaInfo;
    content?: string;
    isMe?: boolean;
}

export const DocumentMedia: React.FC<DocumentMediaProps> = ({ media, content, isMe = false }) => {
    const fileName = useMemo(() => {
        const parsed = safeParse(content);
        if (parsed && typeof parsed === 'object' && parsed.fileName) return parsed.fileName;
        return content && !content.startsWith('{') ? content : 'Documento';
    }, [content]);

    const safeUrl = sanitizeUrl(media.url || '');

    return (
        <div className={`p-3 flex items-center gap-3 rounded-lg m-1 max-w-[280px] ${
            isMe
                ? 'bg-white/15 border border-white/25'
                : 'bg-surface-subtle border border-border'
        }`}>
            <div className={`p-2 rounded-lg shadow-sm flex-shrink-0 ${
                isMe ? 'bg-white/20' : 'bg-white'
            }`}>
                <AppIcon name="clipboard-doc" className={`w-6 h-6 ${isMe ? 'text-white' : 'text-red-500'}`} />
            </div>
            <div className="flex-1 min-w-0">
                <p className={`text-xs font-medium truncate mb-1 ${
                    isMe ? 'text-white' : 'text-text'
                }`} title={fileName}>{fileName}</p>
                {safeUrl ? (
                    <a
                        href={safeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-xs font-medium ${
                            isMe
                                ? 'text-white/70 hover:text-white'
                                : 'text-primary hover:text-primary-dark'
                        }`}
                    >
                        Baixar arquivo
                    </a>
                ) : (
                    <span className={`text-xs ${isMe ? 'text-white/60' : 'text-muted'}`}>
                        Arquivo indisponível
                    </span>
                )}
            </div>
        </div>
    );
};
